module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Prologue"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Journey to War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Rouge Croix and Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" Trench and Billet")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" A Sanctuary and Holding a Line")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Raid")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" Craters and the Colour Blue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Somme and Mametz Wood")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 8")]), _vm._v(" A Respite of Sorts")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 9")]), _vm._v(" The Yser Canal")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 10")]), _vm._v(" Sniping School and Observation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 11")]), _vm._v(" 1917–1918")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0